<template>
    <div class="navbar">
        <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container"
                   @toggleClick="toggleSideBar"/>

        <breadcrumb id="breadcrumb-container" class="breadcrumb-container"/>

        <div class="right-menu">
            <!--<error-log class="errLog-container right-menu-item hover-effect"/>-->
            <template v-if="device!=='mobile'">
                <!--<search id="header-search" class="right-menu-item"/>-->
                <!--<div class="class-version"></div>-->
                <div class="class-version">
                    <el-tag type="warning" effect="dark" size="mini">{{sysInfo.version}}</el-tag>
                </div>
                <!--<error-log class="errLog-container right-menu-item hover-effect"/>-->

                <screenfull id="screenfull" class="right-menu-item hover-effect"/>

                <!--<el-tooltip content="Global Size" effect="dark" placement="bottom">-->
                <!--<size-select id="size-select" class="right-menu-item hover-effect" />-->
                <!--</el-tooltip>-->

            </template>

            <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
                <div class="avatar-wrapper">
                    <img :src="userInfo.picUrl?baseURL+userInfo.picUrl:imgUrl" class="user-avatar">
                    <!--<span class="user-name">{{userInfo.username}}</span>-->
                    <i class="el-icon-caret-bottom"/>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <a @click="personal">
                        <el-dropdown-item>个人信息</el-dropdown-item>
                    </a>
                    <!--<a target="_blank" href="https://baidu.com">-->
                    <!--<el-dropdown-item>百度一下</el-dropdown-item>-->
                    <!--</a>-->
                    <el-dropdown-item divided>
                        <span style="display:block;" @click="logout">退出登录</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <el-dialog ref="ruleForm" v-el-drag-dialog title="个人设置" :visible.sync="dialogFormVisible"
                   :modal-append-to-body="false">
            <dialogLogin :userArr="userArr" @cancel="cancel" @submit="submit"></dialogLogin>
        </el-dialog>
    </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex'
    import Breadcrumb from '../../components/Breadcrumb'
    import Hamburger from '@/components/Hamburger'
    import ErrorLog from '@/components/ErrorLog'
    import Screenfull from '@/components/Screenfull'
    import SizeSelect from '@/components/SizeSelect'
    // import Search from '@/components/HeaderSearch'
    import elDragDialog from '@/directive/el-drag-dialog' // base on element-ui
    import dialogLogin from '@/views/component/dialogLogin/dialogLogin.vue' // base on element-ui
    import {queryCurrentUser} from '@/api/system'
    import {baseURL} from "@/settings.js"

    export default {
        components: {
            Breadcrumb,
            Hamburger,
            ErrorLog,
            Screenfull,
            SizeSelect,
            // Search,
            dialogLogin
        },
        computed: {
            ...mapGetters([
                'sidebar',
                'avatar',
                'device'
            ]),
            ...mapState({
                userInfo: state => state.user.userInfo || {},
                sysInfo: state => state.user.sysInfo || {}
            })
        },
        directives: {elDragDialog},
        data() {
            return {
                dialogFormVisible: false,
                userArr: '',
                userId: '',
                imgUrl: require("../../assets/img/user-avatar-default-blue.png"),
                baseURL,
                flag: '',
            }
        },
        methods: {
            submit() {
                this.dialogFormVisible = false
            },
            cancel() {
                this.dialogFormVisible = false
            },
            async personal() {
                let res = await queryCurrentUser()
                if (res.code == 0) {
                    this.userArr = res.data.user
                    this.dialogFormVisible = true
                } else {
                    this.$message.error(res.msg);
                }

            },
            toggleSideBar() {
                this.$store.dispatch('app/toggleSideBar')
            },
            async logout() {
                await this.$store.dispatch('user/logout')
                this.$router.push(`/login?redirect=${this.$route.fullPath}`)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .navbar {
        height: 50px;
        overflow: hidden;
        position: relative;
        background: #fff;
        box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

        .hamburger-container {
            line-height: 46px;
            height: 100%;
            float: left;
            cursor: pointer;
            transition: background .3s;
            -webkit-tap-highlight-color: transparent;

            &:hover {
                background: rgba(0, 0, 0, .025)
            }
        }

        .breadcrumb-container {
            float: left;
        }

        .errLog-container {
            display: inline-block;
            vertical-align: top;
        }

        .right-menu {
            float: right;
            height: 100%;
            line-height: 50px;
            min-width: 300px;
            text-align: right;
            .class-version {
                display: inline-block;
                vertical-align: top !important;
                height: 100%;
            }
            &:focus {
                outline: none;
            }

            .right-menu-item {
                display: inline-block;
                padding: 0 8px;
                height: 100%;
                font-size: 18px;
                color: #5a5e66;
                /*vertical-align: text-bottom;*/

                &.hover-effect {
                    cursor: pointer;
                    transition: background .3s;

                    &:hover {
                        background: rgba(0, 0, 0, .025)
                    }
                }
            }

            .avatar-container {
                margin-right: 30px;

                .avatar-wrapper {
                    /*margin-top: 5px;*/
                    position: relative;
                    .user-avatar {
                        cursor: pointer;
                        width: 35px;
                        height: 35px;
                        border-radius: 6px;
                        vertical-align: middle;
                    }
                    .user-name {
                        vertical-align: middle;
                        font-size: 16px;
                    }

                    .el-icon-caret-bottom {
                        cursor: pointer;
                        position: absolute;
                        right: -20px;
                        top: 25px;
                        font-size: 14px;
                        vertical-align: middle;
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
    .navbar {
        .el-dialog__wrapper {
            z-index: 999999999;
        }
    }

</style>
